import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { bannerSchema, BannerFormValues } from "@modules/banners/validations/bannerSchema";
import { useCreateBannerMutation } from "@modules/banners/services/mutations";

export function useBannerCreateForm() {
  const { mutateAsync, isPending } = useCreateBannerMutation();

  const methods = useForm<BannerFormValues>({
    resolver: zodResolver(bannerSchema()),
    defaultValues: {
      type: "discount",
      priority: 0,
      active: true,
    },
    mode: "onBlur",
  });

  const {
    handleSubmit,
  } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}
